export function calculateRemainingTime(endTimestamp) {
    if (typeof endTimestamp !== 'number')
        return;
    const now = Math.floor(Date.now() / 1000);
    let remaining = endTimestamp - now;
    let finished = false;
    if (remaining < 0) {
        finished = true;
        remaining = 0;
    }
    return { finished, remaining };
}
export function convertSecondsToDisplayTime(remaining) {
    const sec = remaining % 60;
    const min = parseInt(remaining / 60) % 60;
    const hrsWithoutDay = parseInt(remaining / 3600);
    const hrs = hrsWithoutDay % 24;
    const day = parseInt(remaining / 86400);
    return { day, hrs, hrsWithoutDay, min, sec };
}
